import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Separator } from 'telia-front-react';
import { AddressEvents } from '@teliaee/telia-common-components';
import config from '../../Config';
import InternetCalculatorStore from '../../stores/InternetCalculatorStore';
import SsoStore from '../../stores/SsoStore';
import { TranslationsContext } from '@teliaee/telia-translate';

export interface AddressEventsContainerProps {
  calculatorKey: string;
  ssoStore?: SsoStore;
  internetCalculatorStore?: InternetCalculatorStore;
  disableTranslationsStatistics?: boolean;
  isTestEnvironment?: boolean;
}

function AddressEventsContainer(props: AddressEventsContainerProps): JSX.Element {
  const translations = React.useContext(TranslationsContext).translations;
  const {
    ssoStore: { isDealer },
    internetCalculatorStore,
    calculatorKey,
    disableTranslationsStatistics,
    isTestEnvironment,
  } = props;

  if (!isDealer) {
    return null;
  }

  const getAddressParams = () => {
    const state = internetCalculatorStore.getState(calculatorKey);
    if (!state.address) {
      return null;
    }

    const addressId = state.address.id;
    const buildingId = state.address.buildingId;
    const roomId = state.room ? state.room.roomId : null;
    const addressText = state.address.label;
    const roomText = state.room ? state.room.roomName : '';

    return { addressId, buildingId, roomId, addressText, roomText };
  };

  return (
    <>
      <Separator spacing="xsmall" color="invisible" />
      <AddressEvents
        addressParams={getAddressParams()}
        translations={translations}
        buttonProps={{ type: 'employee', size: 'small' }}
        showHeading={false}
        showEmpty={false}
        showAddNewAddressEvent={true}
        app="public"
        disableTranslationsStatistics={disableTranslationsStatistics}
        isTestEnvironment={isTestEnvironment}
        tier={config.componentTier}
      />
    </>
  );
}

export default inject('ssoStore', 'internetCalculatorStore')(observer(AddressEventsContainer));
